import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UiStateService {
  private drawerOpenBS = new BehaviorSubject<boolean>(false);
  drawerOpen$: Observable<boolean> = this.drawerOpenBS.asObservable();

  openDrawer(): void {
    this.drawerOpenBS.next(true);
  }

  closeDrawer(): void {
    this.drawerOpenBS.next(false);
  }

  toggleDrawer(): void {
    this.drawerOpenBS.next(!this.drawerOpenBS.value);
  }
}
